import Image from "next/image";
import React, { CSSProperties } from "react";

export function LazyImage(props: {
  src: string;
  alt: string;
  width: number;
  height: number;
  style?: CSSProperties;
}) {
  const blurDataURL = "L042M39F00?b%MIU9F?b00xu-;%M";

  return (
    <Image
      alt={props.alt}
      src={props.src}
      width={props.width}
      height={props.height}
      style={props.style}
      loading="lazy"
      placeholder="blur"
      blurDataURL={blurDataURL}
    />
  );
}
